import { MenuItemProps } from './types'
import { ChipMenuItem } from './variants/ChipMenuItem'
import { DefaultMenuItem } from './variants/DefaultMenuItem'

export function MenuItem({ variant, ...rest }: MenuItemProps) {
  switch (variant) {
    case 'default':
      return <DefaultMenuItem {...rest} />
    case 'chip':
      return <ChipMenuItem {...rest} />
  }
}
